<template>
  <div class="l_model_change_faq">
    <div class="container">
      <div class="content">
        <p>
          6月上旬に予定しているアプリ5.3.0のアップデートの際に香の川製麺アプリのiOS端末のOSのサポート範囲がiOS10以上から<span style="font-weight: bold">iOS12以上</span>に変更になります。
          <br />
          <br />
          iOS10をお使いののお客様は、<span style="font-weight: bold">iOS12以上へOSのアップデート</span>をお願いします。また、iOS12以上にアップデートできない端末をお使いのお客様は、AppStoreから<span style="font-weight: bold">次のバージョン（5.3.0）以降のアプリをアップデートできなくなります</span>ので、あらかじめご了承ください。
          <br />
          <br />
          iOS12以上にOSアップデートができない端末は下記となります。
          <br />
          <span style="font-weight: bold">
            ・iPhone 5<br />
            ・iPad 第4世代<br />
            ・iPad mini 第1世代<br />
            ・iPod Touch 第5世代<br />
          </span>
          <br />
          また、5.2.0のバージョンのアプリについては、引き続きご利用いただけますが、5.3.0で搭載される機能の一部がお使いできない場合がございます。
          <br />
          <br />
          また、将来的に強制アップデートがかかったタイミングでお使いいただけなくなりますのでご注意ください。
          <br />
          <br />
          サポート対象外となった端末をお使いになっているお客様で、<span style="font-weight: bold">「アプリ会員ID」と「パスワード」</span>をお控えの場合は、今後機種変された場合に「香の川製麺公式アプリ」を引き続きご利用いただけます。
          <br />
          <br />
          ご利用可能な端末で再度「香の川製麺公式アプリ」をインストールいただき、お控えいただいている「アプリ会員ID」と「パスワード」を入力してお使いください。
          <br />
          <br />
          有効期限内であれば、アップデート前まで貯められたスタンプやクーポンをご利用いただくことができます。
        </p>
        <router-link to="/faq/model-change" @click.native="tapModelChange">
          <div class="l_button__external">
            <UIButton :label="'ID/パスワードを確認する'" />
          </div>
        </router-link>
        <router-link to="/faq/inquiry" @click.native="tapInquiry">
          <div class="l_button__external">
            <UIButton :label="'お問い合わせ'" />
          </div>
        </router-link>
        <p class="caption">
          ※土・日・祝日にいただいたお問合せは翌営業日の受付となります。<br />
          ※メール受信制限等を設定されている場合、返信メールが受け取れない場合がございます。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import UIButton from '@/components/UIButton'
import { FactoryTrack } from '../constant/firebase.js'
import { mapActions } from 'vuex'
import DateFormatter from '../utils/DateFormatter.js'

export default {
  name: 'FAQiOS',
  components: {
    UIButton
  },
  data: function() {
    return {
      userId: '',
      password: ''
    }
  },
  created() {
    document.title = 'アップデートできない'
    const accTime = new DateFormatter().format(new Date())
    try {
      window.receivedToken = payload => {
        const json = JSON.parse(payload)
        this.userId = json.user_id
        window.receivedToken = null
      }
      // クーポン一覧と同じなので一旦apiTypeを3に設定する
      this.actionRequestToken({
        apiType: '3',
        acc_time: accTime
      })
    } catch (e) {
      console.log(e)
    }
    try {
      window.receivedPassword = payload => {
        this.password = payload
        window.receivedPassword = null
      }
      this.actionRequestPassword()
    } catch (e) {
      console.log(e)
    }
  },
  methods: {
    ...mapActions('Analytics', ['trackEvent']),
    ...mapActions('Native', [
      'actionRequestToken',
      'actionGetScreenShot',
      'actionRequestPassword'
    ]),
    tapModelChange: function() {
      this.trackEvent(FactoryTrack.createFAQModelChange())
    },
    tapInquiry: function() {
      this.trackEvent(FactoryTrack.createFAQInquiry())
    }
  }
}
</script>

<style lang="scss" scoped>
.l_model_change_faq {
  width: 100%;
  min-height: 100%;
  background-color: #ffffff;

  p.caption {
    text-align: left;
    margin: 16px -4px;
    font-size: 10px;
    color: rgb(102, 102, 102);
  }
}

.l_model_change_faq h3,
.l_model_change_faq h4 {
  color: #602209;
}

.l_model_change_faq h4 {
  margin: 10px 0px;
}

.l_model_change_faq .l_button__external {
  width: 250px;
  margin: 20px auto 0;
}

.l_model_change_faq .content {
  background-color: #ffffff;
  text-align: left;
  padding: 20px;
}

.l_model_change_faq .content hr {
  margin-top: 10px;
  margin-bottom: 20px;
  border: none;
  border-bottom: 1px solid #efb90f;
}

.l_model_change_faq .content img {
  margin-top: 20px;
  margin-bottom: 10px;
  max-width: 100%;
}

.l_model_change_faq span.strong {
  font-weight: bold;

  &.red {
    color: #cc0000;
  }
}

.screenshot {
  text-align: center;

  img {
    width: 75%;
    margin: auto 0;
  }
}

p.account-info {
  margin-top: 1em;
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: bold;
}

div.border {
  margin: 0;
  padding: 20px 0;
  border-top: 1px solid gray;
  text-align: left;

  &.bottom {
    border-bottom: 1px solid gray;
  }

  .caption {
    display: block;
    font-size: 12px;
    text-align: left;
  }
}

.mail button {
  padding-left: 20px;
  padding-right: 20px;
}

img {
  max-width: 80%;
  width: 188px;
  display: block;
  border: 1px solid #dedede;
  margin: 0 auto;
}

.strong {
  font-weight: bold;
}

.strong-red {
  font-weight: bold;
  color: #e03535;
}
</style>
